import React from 'react';

function Resume() {
    return (
      <div className="App">
          <iframe src={`${process.env.PUBLIC_URL}/Mladen_Milesic_Resume.pdf`} 
          title="Mladen Milesic Resume" 
          style={{
            width: '100%',
            height: '100vh',
            border: 'none', // Remove border
            overflow: 'hidden', // Disable scrolling
          }}
          />
      </div>
    );
  }
  

export default Resume;
